import { gsap, ScrollTrigger } from 'gsap/all';

import DOMHelper from "../../../lib/dom-helper";

export default class HistorySection {
	constructor(props = {}) {
		this.$root = props.$root || null;

		if (this.$root && window.matchMedia('(min-width: 1025px)').matches) {
			this.init();
		}
	}

	init() {
		gsap.registerPlugin(ScrollTrigger);
		this.$gallery = this.$root.querySelector('.history-gallery');
		this.$timeline = this.$root.querySelector('.history-timeline');

		this.initGalleryMovingAnimation();
	}

	initGalleryMovingAnimation() {
		const timelineHeight = this.$timeline.offsetHeight - 30;
		const galleryHeight = this.$gallery.offsetHeight;
		const path = timelineHeight - galleryHeight;
		const step = galleryHeight / timelineHeight;

		this.gsap = gsap.to(this.$gallery, {
			scrollTrigger: {
				trigger: this.$root,
				start: 'top',
				end: 'bottom 100%',
				scrub: true
			},
			y: path,
			translateY: step,
			ease: 'none',
			duration: 1,
			paused: window.matchMedia('(max-width: 768px)').matches
		});
	}
}